import SegmentGenerator from "@/components/segment-generator";
import SegmentContainer from "./segments/segment-container";
import CallToActionButton from "@/components/call-to-action-button";
import Head from "next/head";
import Layout from "@/components/layout";
import classNames from "classnames";
import ratingSchema from "@/components/rating-schema-jsonld";

import { OPTIMIZE_COOKIE_NAME } from "@/lib/constants";
import Cookies from "js-cookie";
import TagManager from "react-gtm-module";
import { useEffect } from "react";
import DutiesTaxesSegment from "./duties-taxes-segment";

export default function CountryPage({
  pageContent,
  preview,
  isoCode,
  comparison,
  countryName,
}) {
  useEffect(() => {
    const cookie = Cookies.get(OPTIMIZE_COOKIE_NAME);
    if (cookie) {
      const [experimentID, variantID] = cookie.split(".");
      // GTM
      TagManager.dataLayer({
        dataLayer: {
          event: "experiment_impression",
          experiment_id: experimentID,
          variant_id: variantID,
        },
      });
    }
  }, []);

  const heroBanner = pageContent.segments[0];
  const otherSegments = pageContent.segments.slice(1);

  return (
    <Layout preview={preview}>
      <Head>
        <title>{pageContent.title}</title>
        <meta name="description" content={pageContent.metaDescription} />
        <meta property="og:title" content={pageContent.title} />
        <meta property="og:description" content={pageContent.metaDescription} />
        <meta
          property="og:url"
          content={`${process.env.NEXT_PUBLIC_HOST}/${pageContent.slug.current}`}
        />
        <meta property="og:type" content="article" />
        <meta
          property="article:modified_time"
          content={pageContent._updatedAt}
        ></meta>
        <meta property="og:site_name" content="JustShip" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:site_name" content={pageContent.title}></meta>
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:label1" content="Est. reading time" />
        <meta name="twitter:data1" content="3 minutes" />
        {ratingSchema()}
      </Head>
      <div className="bg-background-dark-gray">
        <SegmentGenerator key={heroBanner._id} segment={heroBanner} />
        <SegmentContainer className="py-8 md:py-14 h-full">
          <div
            className={classNames(
              "flex flex-col justify-center items-center md:items-start",
              "md:grid grid-cols-[38.2%_61.8%] mx-auto"
            )}
          >
            <div className="text-center md:text-left mb-6 md:mb-0">
              {countryName === "United Kingdom" ? (
                <h2 className="text-xl md:text-2xl font-medium">
                  Singapore to <span className="font-bold italic">UK</span>{" "}
                  <br />
                  Shipping Time & Shipping Rates Comparison
                </h2>
              ) : (
                <h2 className="text-xl md:text-2xl font-medium">
                  Shipping Rates to{" "}
                  <span className="font-bold italic">
                    <br />
                    {countryName}
                  </span>{" "}
                  Comparison
                </h2>
              )}
              <CallToActionButton
                className="mt-8 hidden w-52 md:block leading-tight"
                href="/create-shipment"
              >
                Ship Now
              </CallToActionButton>
            </div>
            <div className="md:pl-8">
              <table
                className={classNames(
                  "border-collapse border-y border-y-light-purple",
                  "text-sm sm:text-base w-full table-fixed md:table-auto"
                )}
              >
                <thead className="text-left align-top">
                  <tr>
                    <th className="py-2 px-2 md:px-4">
                      <p>Company</p>
                    </th>
                    <th className="py-2 px-2 md:px-4">
                      <p>Duration</p>
                    </th>
                    <th className="py-2 px-2 md:px-4">
                      <p>Price 2kg</p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(comparison).map((company) => {
                    const { duration } = comparison[company];
                    return (
                      <tr
                        key={company}
                        className="border-y border-y-light-purple text-sm md:text-base"
                      >
                        <td className="py-2 px-2 md:px-4">
                          <p className="w-min pr-2 md:pr-0">{company}</p>
                        </td>
                        <td className="py-2 px-2 md:px-4">
                          <p className="md:whitespace-nowrap">
                            {duration} Days
                          </p>
                        </td>
                        <td className="py-2 px-2 md:px-4">
                          <p className="">
                            {comparison[company]["2kg"] > 0 &&
                              `$${comparison[company]["2kg"].toFixed(2)}`}
                          </p>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <CallToActionButton
                className="mt-8 md:hidden w-full leading-tight"
                href="/create-shipment"
              >
                Ship Now
              </CallToActionButton>
            </div>
          </div>
        </SegmentContainer>
        <DutiesTaxesSegment isoCode={isoCode} countryName={countryName} />
        {otherSegments.map((segment) => (
          <SegmentGenerator key={segment._id} segment={segment} />
        ))}
      </div>
    </Layout>
  );
}
